import script from "./RouteProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./RouteProgress.vue?vue&type=script&setup=true&lang=js"

import "./RouteProgress.vue?vue&type=style&index=0&id=6f598b49&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f598b49"]])

export default __exports__